import {
  type BDRelationMenuItem,
  relationsIcons,
  type SupportedMetamodels,
} from '@bizzdesign/modeler/models';

export const lineOptionItems: BDRelationMenuItem[] = [
  {
    icon: relationsIcons.Line,
    id: 'LineWithoutArrows',
    label: 'Line',
    labelKey: 'subMenu.lineTooltip',
    sourceShapeType: 'none',
    targetShapeType: 'none',
    leftAnchorIcon: relationsIcons.Line,
    rightAnchorIcon: relationsIcons.Line,
  },
  {
    icon: relationsIcons.Arrow,
    id: 'Line',
    label: 'Line',
    labelKey: 'subMenu.lineTooltip',
    sourceShapeType: 'none',
    targetShapeType: 'triangle',
    leftAnchorIcon: relationsIcons.Line,
    rightAnchorIcon: relationsIcons.Arrow,
  },
];

export const archiMateRelationOptionItems = [
  {
    icon: relationsIcons.CompositionRelation,
    id: 'CompositionRelation',
    label: 'Composition',
  },
  {
    icon: relationsIcons.AggregationRelation,
    id: 'AggregationRelation',
    label: 'Aggregation',
  },
  {
    icon: relationsIcons.TriggeringRelation,
    id: 'TriggeringRelation',
    label: 'Triggering',
  },
  {
    icon: relationsIcons.FlowRelation,
    id: 'FlowRelation',
    label: 'Flow',
  },
  {
    icon: relationsIcons.AccessRelation,
    id: 'AccessRelation',
    label: 'Access',
  },
  {
    icon: relationsIcons.AssignmentRelation,
    id: 'AssignmentRelation',
    label: 'Assignment',
  },
  {
    icon: relationsIcons.RealisationRelation,
    id: 'RealisationRelation',
    label: 'Realisation',
  },
  {
    icon: relationsIcons.ServingRelation,
    id: 'ServingRelation',
    label: 'Serving',
  },
  {
    icon: relationsIcons.AssociationRelation,
    id: 'AssociationRelation',
    label: 'Association',
  },
  {
    icon: relationsIcons.InfluenceRelation,
    id: 'InfluenceRelation',
    label: 'Influence',
  },
  {
    icon: relationsIcons.SpecializationRelation,
    id: 'SpecializationRelation',
    label: 'Specialization',
  },
];

export const bdcoreRelationOptionItems: BDRelationMenuItem[] = [
  {
    icon: relationsIcons.DependencyRelation,
    id: 'DependencyRelation',
    label: 'Dependency',
    labelKey: 'subMenu.dependencyTooltip',
    leftAnchorIcon: relationsIcons.Line,
    rightAnchorIcon: relationsIcons.DependencyRelation,
  },
  {
    icon: relationsIcons.HierarchyRelation,
    id: 'HierarchyRelation',
    label: 'Hierarchy',
    labelKey: 'subMenu.hierarchyTooltip',
    leftAnchorIcon: relationsIcons.HierarchyRelation,
    rightAnchorIcon: relationsIcons.Line,
  },
];
export const relationsConfig: {
  [key in SupportedMetamodels]: BDRelationMenuItem[];
} = {
  BDCore: bdcoreRelationOptionItems,
  FreeFormat: bdcoreRelationOptionItems,
  ArchiMate: archiMateRelationOptionItems,
  BPMN: [],
};
